module.exports = __webpack_public_path__ + "img/fdi_blue_curve.151b14a5.png";